<div class="sgt-cliente-analise-mercado-periodicidade-filter">
    <sgt-datepicker [(ngModel)]="filter.data" name="filterPeriodicidade" id="filterPeriodicidade"
        #dataFilter="ngModel" #dataDatepicker [ngControl]="dataFilter" 
        inputPrependText="Periodicidade"
        [mode]="datepickerMode"
        [showBtnCalendar]="false"
        [withNavigation]="true"
        [showPeriodicidadeMensal]="true"
        [showPeriodicidadeTrimestral]="true"
        [showPeriodicidadeSemestral]="true"
        [showPeriodicidadeAnual]="true"
        [(periodicidade)]="filter.periodicidade"
        (periodicidadeChange)="onChangePeriodicidade($event)"
        [(mes)]="filter.mes"
        [(trimestre)]="filter.trimestre"
        [(semestre)]="filter.semestre"
        [(ano)]="filter.ano"
        (ngModelChange)="onChangeData()"
        [disabled]="!isFilterInitialized">
    </sgt-datepicker> 
</div>